import { CSS, StyleProps } from "../styles"

export type StatusBarType = `error` | `info` | `important`
export type StatusBarPlacement = `top` | `bottom` | `belowTitle` | `middle`

const getBackgroundColor = (type: StatusBarType, props: StyleProps) => {
  if (type === `error`) return props.theme.palette.error
  if (type === `important`) return props.theme.palette.important
  return props.theme.palette.coal.dark
}

export const getRootStyle =
  (type: StatusBarType, placement?: StatusBarPlacement) =>
  (props: StyleProps): CSS => ({
    alignItems: `middle`,
    backgroundColor: getBackgroundColor(type, props),
    borderRadius: props.theme.borderRadius.md,
    color: props.theme.palette.white,
    justifyContent: `space-between`,
    marginBottom: placement !== `bottom` && placement !== `middle` ? props.theme.spacing(4) : 0,
    marginTop: placement === `bottom` ? props.theme.spacing(4) : 0,
    padding: props.theme.spacing(3, 3, 3, 4),
  })

export const text = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.caption,
})

export const title = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(1),
})

export const dismiss = (props: StyleProps): CSS => ({
  ...props.theme.fonts.heading,
  cursor: `pointer`,
})
